export default __webpack_public_path__ + "static/media/union2.9167618c.svg";